import React, { FC, Fragment } from 'react';
import { IAutocompleteField } from 'types/shared';
import { CustomTypography } from '../Input.styled';
import { DraggableSelectOptionCheckbox } from './DraggableSelect.styled';

interface IProps {
  selected: boolean;
  disabled?: boolean;
  option: IAutocompleteField;
  isTaxonomy?: boolean;
}

const DraggableSelectOption: FC<IProps> = ({ disabled, selected, option: { label, taxonomies }, isTaxonomy }) => {
  const parseTaxonomyOption = (): Array<JSX.Element> => {
    if (taxonomies) {
      const taxonomiesLength = taxonomies.length;

      return taxonomies.map((value, index) => (
        <Fragment key={index}>
          <span>{value.name}</span>
          {taxonomiesLength > 1 && index < taxonomiesLength - 1 && <span>/</span>}
        </Fragment>
      ));
    }

    return [];
  };

  return (
    <Fragment>
      <DraggableSelectOptionCheckbox checked={selected} disabled={disabled} />
      <CustomTypography color="textSecondary" variant="subtitle2" taxonomy={isTaxonomy?.toString()}>
        {isTaxonomy ? parseTaxonomyOption() : label}
      </CustomTypography>
    </Fragment>
  );
};

export default DraggableSelectOption;
